import React, { ReactNode } from "react";
import styled from "styles/styled_components";

const StyledTabPanel = styled.div`
  outline: none;
`;

export interface ITabPanel {
  children: ReactNode;
  tabId: string;
}

export default function TabPanel({ children, tabId }: ITabPanel) {
  return (
    <StyledTabPanel
      aria-labelledby={`${tabId}-tab`}
      id={`${tabId}-tabpanel`}
      role="tabpanel"
      tabIndex={0}>
      {children}
    </StyledTabPanel>
  );
}
